export default "__VITE_ASSET__Z4zobI7Y__"